const FemaleTitles = ['mrs', 'ms', 'miss']
const MaleTitles = ['mr']

export type Gender = 'MALE' | 'FEMALE' | 'UNKNOWN'

export const mapToGender = (title?: string): Gender => {
  if (!title) return 'UNKNOWN'

  if (FemaleTitles.indexOf(title.toLowerCase()) > -1) {
    return 'FEMALE'
  }
  if (MaleTitles.indexOf(title.toLowerCase()) > -1) {
    return 'MALE'
  }
  return 'UNKNOWN'
}
